import {get} from 'api/http'

export function fetch(panelId) {
    return get('unit_diagnostic/features', {unt_id: panelId})
}